import {EntityModel} from "@fedeltapointofsale/data-client";
import {SalePeriodData} from "./sale-period.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class SalePeriodEntityModel extends EntityModel<SalePeriodData> {
    constructor(injector: Injector) {
        super(injector, SalePeriodData);
    }
}
